import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard,
  FileText,
  Package,
  Wallet,
  Film,
  Inbox,
  LogOut,
  ExternalLink,
} from 'lucide-react';
import { Toaster } from '../../components/ui/toaster';

const nav = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/content', label: 'Contenido Web', icon: FileText },
  { to: '/admin/services', label: 'Servicios', icon: Package },
  { to: '/admin/pricing', label: 'Tarifas', icon: Wallet },
  { to: '/admin/works', label: 'Trabajos', icon: Film },
  { to: '/admin/leads', label: 'Leads', icon: Inbox },
];

const AdminLayout = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    signOut();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#0a1420] text-white flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#070f18] border-r border-white/5 flex flex-col fixed inset-y-0 left-0">
        <div className="px-6 py-6 border-b border-white/5">
          <div className="flex items-center gap-3">
            <div className="relative w-10 h-10 rounded-lg bg-gradient-to-br from-[#00e0c7] to-[#00a3ff] flex items-center justify-center">
              <div className="absolute inset-1 rounded-md bg-[#0d1b2a] flex items-center justify-center">
                <span className="text-[#00e0c7] font-bold text-sm">LD</span>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold text-sm">Admin Panel</div>
              <div className="text-[10px] text-white/40 uppercase tracking-widest">Lab.Cine</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    isActive
                      ? 'bg-[#00e0c7]/10 text-[#00e0c7] border border-[#00e0c7]/20'
                      : 'text-white/60 hover:text-white hover:bg-white/5 border border-transparent'
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="px-3 py-4 border-t border-white/5 space-y-2">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors"
          >
            <ExternalLink className="w-4 h-4" />
            Ver web pública
          </a>
          <div className="px-3 py-2 text-[11px] text-white/40">
            Sesión: <span className="text-white/70">{user?.username}</span>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-400 hover:bg-red-500/10 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-64 min-h-screen">
        <div className="p-8 lg:p-10 max-w-6xl">
          <Outlet />
        </div>
      </main>

      <Toaster />
    </div>
  );
};

export default AdminLayout;
